<template>
  <div>
    <div class="mt-3 p-2">
      <b-container fluid class="mb-2">
        <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
        
        
        
        
        <b-form @submit.prevent="submitForm" enctype="multipart/form-data">
          <h5>Edit Announcement Details</h5>
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                id="input-group-1"
                label="Title:"
                label-for="input-1"
              >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                    id="input-1"
                    v-model="form.title"
                    type="text"
                    placeholder="Enter Title"
                    :state="isNameValid"
                    required
                  ></b-form-input>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group id="input-group-2" label="URL:" label-for="input-2">
                <ValidationProvider rules="alpha" v-slot="{ errors }">
                  <b-form-input
                    id="input-2"
                    v-model="form.url"
                    placeholder="Enter URL"
                    :state="getURLFieldState"
                    :disabled="isPDFMode"
                  ></b-form-input>
                  <span class="error">{{ errors[0] }}</span>
                  <small v-if="isPDFMode" class="text-muted">Disabled in PDF mode</small>
                </ValidationProvider>
              </b-form-group>
              
              <b-form-group>
                <b-form-checkbox
                  v-model="form.isLoomVideo"
                  value="true"
                  unchecked-value="false"
                  :disabled="true || isPDFMode"
                >
                  Is Loom Video?
                </b-form-checkbox>
                <small v-if="isPDFMode" class="text-muted">Disabled in PDF mode</small>
              </b-form-group>
              
              <b-form-group
                id="input-group-2"
                label="Description:"
                label-for="input-2"
              >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-textarea
                    id="input-2"
                    v-model="form.description"
                    placeholder="Enter description..."
                    rows="5"
                    max-rows="8"
                    :state="isDescriptionValid"
                  ></b-form-textarea>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
              
              <b-form-group
                id="input-group-3"
                :label="`Images (${totalImagesCount||0}/5):`"
                label-for="input-3"
              >
                <b-form-file
                  accept="image/*"
                  multiple
                  id="file2"
                  ref="file2"
                  :state="
                    Boolean(
                      (newImages && newImages.length > 0) ||
                        (existingImages && existingImages.length > 0)
                    )
                  "
                  :placeholder="isPDFMode ? 'Disabled in PDF mode' : (remainingImagesSlots > 0 ? `Choose up to ${remainingImagesSlots} more images...` : 'Maximum images reached')"
                  :disabled="isPDFMode || remainingImagesSlots === 0"
                  drop-placeholder="Drop file here..."
                  @change="validateImages"
                ></b-form-file>
                <small v-if="isPDFMode" class="text-muted">Disabled in PDF mode</small>
              </b-form-group>

              <!-- Existing Images -->
              <b-row
                v-if="existingImages && existingImages.length > 0"
                class="mb-3"
              >
                <b-col
                  cols="3"
                  v-for="(image, index) in existingImages"
                  :key="'existing-' + index"
                  class="mb-2"
                >
                  <div class="position-relative">
                    <img
                      :src="image"
                      alt="Existing Image"
                      width="100%"
                      height="70%"
                      style="border-radius: 11px; object-fit: cover"
                      :class="{ 'opacity-50': isPDFMode }"
                    />
                    <button
                      type="button"
                      @click="removeExistingImageFromList(index)"
                      class="position-absolute btn btn-sm btn-danger"
                      :disabled="isPDFMode"
                      style="
                        top: 4px;
                        right: 4px;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                      "
                    >
                      ×
                    </button>
                  </div>
                </b-col>
              </b-row>

              <!-- New Images Preview -->
              <b-row v-if="newImages && newImages.length > 0" class="mb-3">
                <b-col
                  cols="3"
                  v-for="(image, index) in newImages"
                  :key="'new-' + index"
                  class="mb-2"
                >
                  <div class="position-relative" v-if="image">
                    <img
                      :src="getFilePreviewUrl(image)"
                      alt="New Image"
                      width="100%"
                      height="70%"
                      style="border-radius: 11px; object-fit: cover"
                      :class="{ 'opacity-50': isPDFMode }"
                      @error="handleImageError"
                    />
                    <button
                      type="button"
                      @click="removeNewImage(index)"
                      class="position-absolute btn btn-sm btn-danger"
                      :disabled="isPDFMode"
                      style="
                        top: 4px;
                        right: 4px;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                      "
                    >
                      ×
                    </button>
                  </div>
                </b-col>
              </b-row>
              
              <b-form-group
                id="input-group-pdfs"
                :label="`PDF File (${totalPDFsCount||0}/1):`"
                label-for="input-pdfs"
              >
                <b-form-file
                  accept=".pdf,application/pdf"
                  id="file4"
                  ref="file4"
                  :state="
                    Boolean(
                      (newPDFs && newPDFs.length > 0) ||
                        (existingPDFs && existingPDFs.length > 0)
                    )
                  "
                  :placeholder="form.isLoomVideo ? 'PDFs not allowed for Loom videos' : (remainingPDFsSlots > 0 ? 'Choose 1 PDF file or drop it here...' : 'Maximum PDF reached')"
                  :disabled="form.isLoomVideo || remainingPDFsSlots === 0"
                  drop-placeholder="Drop PDF file here..."
                  @change="validatePDFs"
                ></b-form-file>
                <small v-if="form.isLoomVideo" class="text-muted">PDFs are not allowed for Loom video announcements</small>
                <small v-else-if="isPDFMode" class="text-success">
                  <i class="fas fa-info-circle"></i> 
                  Only 1 PDF allowed
                </small>
              </b-form-group>

              <!-- Existing PDFs -->
              <div v-if="existingPDFs && existingPDFs.length > 0" class="mb-3">
     
                <ul class="list-group">
                  <li
                    v-for="(pdf, index) in existingPDFs"
                    :key="'existing-pdf-' + index"
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <i class="fas fa-file-pdf text-danger mr-2"></i>
                      {{ getPDFFileName(pdf) }}
                    </span>
                    <div>
                      <a
                        :href="pdf"
                        download
                        class="btn btn-sm btn-outline-success mr-2"
                      >
                        Download
                      </a>
                      <button
                        type="button"
                        @click="removeExistingPDF(index)"
                        class="btn btn-sm btn-danger"
                      >
                        ×
                      </button>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- New PDFs -->
              <div v-if="newPDFs && newPDFs.length > 0" class="mb-3">
                <h6>New PDF Selected:</h6>
                <ul class="list-group">
                  <li
                    v-for="(pdf, index) in newPDFs"
                    :key="'new-pdf-' + index"
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <i class="fas fa-file-pdf text-success mr-2"></i>
                      {{ pdf.name }}
                    </span>
                    <button
                      type="button"
                      @click="removeNewPDF(index)"
                      class="btn btn-sm btn-danger"
                    >
                      ×
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <!-- Cover Image Section -->
              <b-form-group
                id="input-group-2"
                :label="isPDFMode ? 'Cover Image (Required):' : 'Cover Image:'"
                label-for="input-2"
              >
                <b-form-file
                accept="image/*"
                  id="file"
                  ref="file"
                  :state="getImageFieldState"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="validateCoverImage"
                ></b-form-file>
                <small v-if="isPDFMode" class="text-info">Cover image is required in PDF mode</small>
              </b-form-group>

              <!-- Existing Cover Image (only show if no new image selected) -->
              <div
                v-if="existingImage && !form.image"
                class="position-relative d-inline-block mb-4"
              >
                <img
                  :src="existingImage"
                  alt="Current Cover Image"
                  class="d-block"
                  height="200px"
                  width="300px"
                  style="object-fit: cover; border-radius: 8px"
                />
              </div>

              <!-- New Cover Image Preview -->
              <div v-if="form.image" class="mb-4">
                <img
                  :src="getFilePreviewUrl(form.image)"
                  alt="New Cover Image"
                  width="300px"
                  height="200px"
                  style="border-radius: 11px; object-fit: cover"
                  @error="handleImageError"
                />
                <p><strong>New cover image selected:</strong> {{ form.image.name }}</p>
              </div>
              
              <b-form-group
                id="input-group-3"
                :label="`Videos (${totalVideosCount||0}/3):`"
                label-for="input-4"
              >
                <b-form-file
                  multiple
                  id="file3"
                  ref="file3"
                  accept="video/*"
                  :state="
                    Boolean(
                      (newVideos && newVideos.length > 0) ||
                        (existingVideos && existingVideos.length > 0)
                    )
                  "
                  :placeholder="isPDFMode ? 'Disabled in PDF mode' : (remainingVideosSlots > 0 ? `Choose up to ${remainingVideosSlots} more videos...` : 'Maximum videos reached')"
                  :disabled="isPDFMode || remainingVideosSlots === 0"
                  drop-placeholder="Drop file here..."
                  @change="validateVideos"
                ></b-form-file>
                <small v-if="isPDFMode" class="text-muted">Disabled in PDF mode</small>
              </b-form-group>
              
              <!-- Existing Videos -->
              <b-row
                v-if="existingVideos && existingVideos.length > 0"
                class="mb-3"
              >
                <b-col
                  cols="3"
                  v-for="(video, index) in existingVideos"
                  :key="'existing-video-' + index"
                  class="mb-2"
                >
                  <div class="position-relative">
                    <video
                      width="100%"
                      height="70%"
                      controls
                      style="border-radius: 8px"
                      :class="{ 'opacity-50': isPDFMode }"
                    >
                      <source :src="video" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <button
                      type="button"
                      @click="removeExistingVideo(index)"
                      class="position-absolute btn btn-sm btn-danger"
                      :disabled="isPDFMode"
                      style="
                        top: 4px;
                        right: 4px;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                      "
                    >
                      ×
                    </button>
                  </div>
                </b-col>
              </b-row>

              <!-- New Videos Preview -->
              <b-row v-if="newVideos && newVideos.length > 0" class="mb-3">
                <b-col
                  cols="3"
                  v-for="(video, index) in newVideos"
                  :key="'new-video-' + index"
                  class="mb-2"
                >
                  <div class="position-relative" v-if="video">
                    <video
                      width="100%"
                      height="70%"
                      controls
                      style="border-radius: 8px"
                      :class="{ 'opacity-50': isPDFMode }"
                    >
                      <source
                        :src="getFilePreviewUrl(video)"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <button
                      type="button"
                      @click="removeNewVideo(index)"
                      class="position-absolute btn btn-sm btn-danger"
                      :disabled="isPDFMode"
                      style="
                        top: 4px;
                        right: 4px;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                      "
                    >
                      ×
                    </button>
                  </div>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col cols="12" class="d-flex justify-content-center">
                  <b-spinner
                    class="text-center"
                    v-if="isUploading"
                    variant="success"
                    type="grow"
                    label="Uploading..."
                  ></b-spinner>
                </b-col>
              </b-row>
            </div>
            <div class="col-md-6">
              <b-button
                size="sm"
                :disabled="isDisable"
                variant="success"
                @click="submitForm()"
              >
                Update
              </b-button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      farmDetails: "",
      form: {
        title: "",
        description: "",
        url: "",
        image: null,
        images: [],
        videos: [],
        pdfs: [],
        isLoomVideo: false,
      },
      // Existing file holders
      existingImage: null,
      existingImages: [],
      existingVideos: [],
      existingPDFs: [],
      // New files to be uploaded
      newImages: [],
      newVideos: [],
      newPDFs: [],
      isDisable: false,
      success: false,
      isUploading: false,
    };
  },
  mounted() {
    this.getAnnouncementDetails();
  },
  computed: {
    isNameValid() {
      return this.form.title.length > 0;
    },

    isDescriptionValid() {
      return this.form.description.length > 0;
    },
    
    getImageFieldState() {
      
      if (this.isPDFMode) {
        return Boolean(this.form.image || this.existingImage);
      }
 
      if (this.form.isLoomVideo) {
        return null;
      }
      return (this.form.image instanceof File || this.existingImage) ? true : null;
    },
    
    getURLFieldState() {
      if (this.form.isLoomVideo) {
        if (!this.form.url) {
          return false;
        }
        return this.validateLoomURL() ? true : false;
      }
      return null;
    },


    isPDFMode() {
      const totalPDFs = (this.existingPDFs?.length || 0) + (this.newPDFs?.length || 0);
      return totalPDFs > 0 && !this.form.isLoomVideo;
    },

    totalImagesCount() {
      return (this.existingImages?.length || 0) + (this.newImages?.length || 0);
    },
    
    totalVideosCount() {
      return (this.existingVideos?.length || 0) + (this.newVideos?.length || 0);
    },
    
    totalPDFsCount() {
      return (this.existingPDFs?.length || 0) + (this.newPDFs?.length || 0);
    },
    
    remainingImagesSlots() {
      return this.isPDFMode ? 0 : Math.max(0, 5 - this.totalImagesCount);
    },
    
    remainingVideosSlots() {
      return this.isPDFMode ? 0 : Math.max(0, 3 - this.totalVideosCount);
    },
    
    remainingPDFsSlots() {
      // Disable PDFs if it's a Loom video
      if (this.form.isLoomVideo) {
        return 0;
      }
      return Math.max(0, 1 - this.totalPDFsCount);
    }
  },

  watch: {

    'newImages'() {
      if (this.newImages && this.newImages.length > 0 && this.isPDFMode && !this.form.isLoomVideo) {
        this.clearAllPDFs();
      }
    },
    'newVideos'() {
      if (this.newVideos && this.newVideos.length > 0 && this.isPDFMode && !this.form.isLoomVideo) {
        this.clearAllPDFs();
      }
    },
    'form.url'() {
      if (this.form.url && this.form.url.trim().length > 0 && this.isPDFMode && !this.form.isLoomVideo) {
        this.clearAllPDFs();
      }
    },
  
    'existingImages'() {
      if (this.existingImages && this.existingImages.length > 0 && this.isPDFMode && !this.form.isLoomVideo) {
        this.clearAllPDFs();
      }
    },
    'existingVideos'() {
      if (this.existingVideos && this.existingVideos.length > 0 && this.isPDFMode && !this.form.isLoomVideo) {
        this.clearAllPDFs();
      }
    }
  },

  methods: {
    clearAllPDFs() {
     
      this.existingPDFs = [];
      this.newPDFs = [];
      this.$refs.file4?.reset();
    },

    clearOtherFilesForPDFMode() {
   
      this.form.url = "";
      this.form.isLoomVideo = false;
      this.existingImages = [];
      this.newImages = [];
      this.existingVideos = [];
      this.newVideos = [];
      
   
      this.$refs.file2?.reset();
      this.$refs.file3?.reset();
    },

    getAnnouncementDetails() {
      let announcementID = this.$route.params.id;
      this.$apiV2.get('/announcements/' + announcementID, {}).then((resp) => {
        if (resp.data.success) {
          const data = resp.data.data;
          
         
          this.form.title = data.title;
          this.form.description = data.description;
          this.form.url = data.url;
          this.form.isLoomVideo = data.isLoomVideo;
          
          
          this.existingImage = data.image;
          this.existingImages = [...(data.images || [])];
          this.existingVideos = [...(data.videos || [])];
          this.existingPDFs = [...(data.pdfs || [])];
          
      
          this.form.image = null;
          this.form.images = [];
          this.form.videos = [];
          this.form.pdfs = [];
        }
      });
    },

    validateLoomURL() {
      if (this.form.isLoomVideo && this.form.url) {
        return this.form.url
          .trim()
          .startsWith(process.env.VUE_APP_LOOM_BASEURL);
      }
      return true;
    },

    validateCoverImage(event) {
      const file = event.target.files[0];
      if (file) {
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
          alert("Cover image file size must not exceed 5 MB.");
          this.$refs["file"].reset();
          this.form.image = null;
          return;
        }
        this.form.image = file;
      }
    },

    validateImages(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
      
        if (this.isPDFMode) {
          alert("Cannot add images while in PDF mode. Please remove all PDFs first.");
          this.$refs['file2'].reset();
          return;
        }

        const maxSize = 10 * 1024 * 1024; // 10MB per image
        const maxTotalImages = 5;
        
     
        for (let i = 0; i < files.length; i++) {
          if (files[i].size > maxSize) {
            alert(`Image ${files[i].name} size must not exceed 10 MB.`);
            this.$refs['file2'].reset();
            return;
          }
        }
        
        
        const currentTotal = (this.existingImages?.length || 0) + (this.newImages?.length || 0);
        if (currentTotal + files.length > maxTotalImages) {
          const remaining = maxTotalImages - currentTotal;
          alert(`Maximum ${maxTotalImages} images allowed. You can only add ${remaining} more image(s).`);
          this.$refs['file2'].reset();
          return;
        }
        
        
        this.newImages = [...this.newImages, ...Array.from(files)];
      }
    },

    validateVideos(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        
        if (this.isPDFMode) {
          alert("Cannot add videos while in PDF mode. Please remove all PDFs first.");
          this.$refs['file3'].reset();
          return;
        }

        const maxSize = 50 * 1024 * 1024; // 50MB per video
        const maxTotalVideos = 3;
        
  
        for (let i = 0; i < files.length; i++) {
          if (files[i].size > maxSize) {
            alert(`Video ${files[i].name} size must not exceed 50 MB.`);
            this.$refs['file3'].reset();
            return;
          }
        }
        
        
        const currentTotal = (this.existingVideos?.length || 0) + (this.newVideos?.length || 0);
        if (currentTotal + files.length > maxTotalVideos) {
          const remaining = maxTotalVideos - currentTotal;
          alert(`Maximum ${maxTotalVideos} videos allowed. You can only add ${remaining} more video(s).`);
          this.$refs['file3'].reset();
          return;
        }
        
   
        this.newVideos = [...this.newVideos, ...Array.from(files)];
      }
    },

    validatePDFs(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
      
        const hasOtherFiles = (this.existingImages?.length > 0) || (this.newImages?.length > 0) || 
                             (this.existingVideos?.length > 0) || (this.newVideos?.length > 0) ||
                             (this.form.url && this.form.url.trim().length > 0) || this.form.isLoomVideo;
        
        if (hasOtherFiles) {
          const confirmResult = confirm("Adding PDFs will enable PDF-only mode and remove all other files (images, videos, URLs). Do you want to continue?");
          if (!confirmResult) {
            this.$refs['file4'].reset();
            return;
          }
     
          this.clearOtherFilesForPDFMode();
        }

        const maxSize = 5 * 1024 * 1024; // 5MB per PDF
        const maxTotalPDFs = 1; // Maximum 1 PDF allowed
        
      
        if (files.length > 1) {
          alert("Only 1 PDF file is allowed. Please select a single PDF.");
          this.$refs['file4'].reset();
          return;
        }
        
   
        if (files[0].size > maxSize) {
          alert(`PDF ${files[0].name} size must not exceed 5 MB.`);
          this.$refs['file4'].reset();
          return;
        }
        
        
        const currentTotal = (this.existingPDFs?.length || 0) + (this.newPDFs?.length || 0);
        if (currentTotal >= maxTotalPDFs) {
          alert("Maximum 1 PDF allowed. Please remove the existing PDF first.");
          this.$refs['file4'].reset();
          return;
        }
        
     
        this.newPDFs = [files[0]];
      }
    },

    removeExistingImageFromList(index) {
      if (this.isPDFMode) {
        alert("Cannot modify images while in PDF mode.");
        return;
      }
      this.existingImages.splice(index, 1);
    },

    removeNewImage(index) {
      if (this.isPDFMode) {
        alert("Cannot modify images while in PDF mode.");
        return;
      }
  
      if (this.newImages[index]) {
        try {
          URL.revokeObjectURL(this.getFilePreviewUrl(this.newImages[index]));
        } catch (error) {
          console.warn('Error revoking object URL:', error);
        }
      }
      this.newImages.splice(index, 1);
      this.$refs['file2'].reset();
    },

    removeExistingVideo(index) {
      if (this.isPDFMode) {
        alert("Cannot modify videos while in PDF mode.");
        return;
      }
      this.existingVideos.splice(index, 1);
    },

    removeNewVideo(index) {
      if (this.isPDFMode) {
        alert("Cannot modify videos while in PDF mode.");
        return;
      }
 
      if (this.newVideos[index]) {
        try {
          URL.revokeObjectURL(this.getFilePreviewUrl(this.newVideos[index]));
        } catch (error) {
          console.warn('Error revoking object URL:', error);
        }
      }
      this.newVideos.splice(index, 1);
      this.$refs['file3'].reset();
    },

    removeExistingPDF(index) {
      this.existingPDFs.splice(index, 1);
    },

    removeNewPDF(index) {
      this.newPDFs.splice(index, 1);
      this.$refs['file4'].reset();
    },

    getFilePreviewUrl(file) {
 
      if (!file || !(file instanceof File || file instanceof Blob)) {
        console.warn('getFilePreviewUrl expects a File object, got:', typeof file);
        return '';
      }
      
      try {
        return URL.createObjectURL(file);
      } catch (error) {
        console.error('Error creating object URL:', error);
        return '';
      }
    },

    handleImageError(event) {
      console.error('Image failed to load:', event.target.src);
      event.target.style.display = 'none';
    },

    submitForm() {
      let validationErrors = [];

   
      if (this.form.title.length === 0) {
        validationErrors.push("Title");
      }
      if (this.form.description.length === 0) {
        validationErrors.push("Description");
      }

     
      if (this.isPDFMode) {
       
        if (!this.form.image && !this.existingImage) {
          validationErrors.push("Cover Image (required in PDF mode)");
        }
        
      
        if (this.totalPDFsCount === 0) {
          validationErrors.push("PDFs");
        }
      } else {
       
        let fileState = Boolean(this.form.image || this.existingImage);
        let urlRequired = this.form.isLoomVideo;
        let coverImageRequired = !this.form.isLoomVideo;

        if (
          urlRequired &&
          (!this.form.url || this.form.url.trim().length === 0)
        ) {
          validationErrors.push("URL");
        }

        if (
          urlRequired &&
          this.form.url &&
          this.form.url.trim().length > 0 &&
          !this.validateLoomURL()
        ) {
          validationErrors.push("Invalid URL");
        }

        if (coverImageRequired && !fileState) {
          validationErrors.push("Cover Image");
        }
      }

      if (validationErrors.length > 0) {
        this.$bvToast.toast(
          `${validationErrors.join(", ")} ${
            validationErrors.length === 1 ? "is" : "are"
          } required!`,
          {
            title: `Error`,
            variant: "danger",
            solid: true,
          }
        );
        return;
      }

      let announcementID = this.$route.params.id;
      let formData = new FormData();

 
      formData.append("title", this.form.title);
      formData.append("description", this.form.description);

    
      if (this.form.image) {
        formData.append("image", this.form.image);
      } else if (this.existingImage) {
        formData.append("existingImage", this.existingImage);
      }

      if (this.isPDFMode) {
      
        formData.append("url", "");
        formData.append("isLoomVideo", false);
        
        
        if (this.existingPDFs?.length > 0) {
          this.existingPDFs.forEach((pdf) =>
            formData.append("existingPDFs[]", pdf)
          );
        }
        if (this.newPDFs?.length > 0) {
          this.newPDFs.forEach((pdf) => formData.append("pdfs", pdf));
        }
      } else {
 
        formData.append("url", this.form.url);
        formData.append("isLoomVideo", this.form.isLoomVideo);

     
        if (this.existingImages?.length > 0) {
          this.existingImages.forEach((image) =>
            formData.append("existingImages[]", image)
          );
        }
        if (this.newImages?.length > 0) {
          this.newImages.forEach((image) => formData.append("images", image));
        }

       
        if (this.existingVideos?.length > 0) {
          this.existingVideos.forEach((video) =>
            formData.append("existingVideos[]", video)
          );
        }
        if (this.newVideos?.length > 0) {
          this.newVideos.forEach((video) => formData.append("videos", video));
        }

        
        if (this.existingPDFs?.length > 0) {
          this.existingPDFs.forEach((pdf) =>
            formData.append("existingPDFs[]", pdf)
          );
        }
        if (this.newPDFs?.length > 0) {
          this.newPDFs.forEach((pdf) => formData.append("pdfs", pdf));
        }
      }

      this.isDisable = true;
      this.isUploading = true;
      this.$apiV2
        .put(`announcements/${announcementID}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          if (resp.data.success) {
            this.success = resp.data.message;

           
            this.form.image = null;
            this.newImages = [];
            this.newVideos = [];
            this.newPDFs = [];

            // Reset file input elements
            this.$refs.file?.reset();
            this.$refs.file2?.reset();
            this.$refs.file3?.reset();
            this.$refs.file4?.reset();
          }
          this.isDisable = false;
          this.isUploading = false;
          setTimeout(
            () => ((this.success = false), this.$router.push("/announcement")),
            3000
          );
        })
        .catch((err) => {
          console.error("Error updating announcement:", err);
          this.isDisable = false;
          this.isUploading = false;
        });
    },

    getPDFFileName(url) {
      const fileName = url.split("/").pop() || "PDFs File";
      return fileName.substring(0, 20) + "...";
    },

   
    beforeDestroy() {
     
      this.newImages.forEach(file => {
        try {
          URL.revokeObjectURL(this.getFilePreviewUrl(file));
        } catch (error) {
          console.warn('Error revoking object URL:', error);
        }
      });
      this.newVideos.forEach(file => {
        try {
          URL.revokeObjectURL(this.getFilePreviewUrl(file));
        } catch (error) {
          console.warn('Error revoking object URL:', error);
        }
      });
      if (this.form.image) {
        try {
          URL.revokeObjectURL(this.getFilePreviewUrl(this.form.image));
        } catch (error) {
          console.warn('Error revoking object URL:', error);
        }
      }
    }
  },
};
</script>
